import React from 'react';
import _ from 'lodash';
import { InspectionViewEvent, InspectionViewEventCategory } from 'types/rest/analyticsTypes';
import styles from './EventTypesLegend.module.css';
import clsx from 'clsx';

type EventTypesLegendProps = {
  executionSteps: InspectionViewEvent[];
};

type EventType = {
  id: InspectionViewEventCategory;
  className: string;
  title: string;
  desc?: string;
};

/**
 *
 * @param executionSteps
 * @constructor
 */
const EventTypesLegend = (props: EventTypesLegendProps) => {
  /**
   * Creates legend and label for each unique event type.
   * */
  const createLegendLabels = () => {
    // Get list of all catagories
    const eventTypes: InspectionViewEventCategory[] = props.executionSteps.map(
      (execStep: InspectionViewEvent) => execStep.category,
    );

    // Remove dupes
    const uniqueTypesInEventList = _.uniq(eventTypes);

    // List of predefined labels, it is fix list in order to have fix
    // ordering. We will just compare whether id is present in unique
    // array of types.
    const predefinedLabels: EventType[] = [
      {
        id: 'ERROR',
        className: styles.eventError,
        title: 'Step error',
      },
      {
        id: 'STEP_FAILED',
        className: styles.eventStepFailed,
        title: 'Step Failed',
      },
      {
        id: 'WARNING',
        className: styles.eventWarning,
        title: 'Step Warning',
      },
      {
        id: 'LOG_WARNING',
        className: styles.eventLogWarn,
        title: 'Log Warning',
      },

      {
        id: 'SET_PROPERTIES',
        className: styles.eventSetProp,
        title: 'Set Property',
      },
      {
        id: 'ASSERT',
        className: styles.eventAssert,
        title: 'Assertion',
      },
      {
        id: 'START',
        className: styles.eventStart,
        title: 'Start',
      },
    ];

    return predefinedLabels
      .filter(
        item =>
          _.findIndex(uniqueTypesInEventList, (uniqueType: InspectionViewEventCategory) => {
            return item.id === String(uniqueType);
          }) !== -1,
      )
      .map((item: EventType) => {
        return (
          <div className="d-inline-block" key={item.id}>
            <span className={clsx(styles.legend, item.className)}></span>
            <span>{item.title}</span>
          </div>
        );
      });
  };

  return <div className="pb-4">{createLegendLabels()}</div>;
};

export default EventTypesLegend;
